import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import useFetch from '../../../hooks/useFetch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const PDPassword = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [buttonClicked, setButtonClicked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmNewPassword, setShowConfirmNewPassword] = useState(false);


  const handleChangePassword = async () => {
    if (currentPassword.length < 8) {
      setError("Current password must be at least 8 characters long.");
      return;
    }
    if (newPassword.length < 8) {
      setError("New password must be at least 8 characters long.");
      return;
    }
    if (newPassword === currentPassword) {
      setError("New password must be different from the current password.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      setError("New password and confirm password do not match.");
      return;
    }

    setError('');
    setButtonClicked(true);

    const config = {
      url: "/auth/changepassword",
      method: "post",
      data: { currentPassword, password: newPassword, userId: authState.user._id },
      headers: { Authorization: authState.token }
    };

    fetchData(config)
      .then(response => {
        if (response.status) {
          setSuccess(true);
          setMessage("Password Changed Successfully! Please login again.");
        } else {
          setMessage("Password not changed! Please try again.");
        }
      })
      .catch(error => {
        console.error('Error changing password:', error);
        setMessage("Error changing password. Please try again.");
      });
  };

  const toggleCurrentPasswordVisibility = () => {
    setShowCurrentPassword(!showCurrentPassword);
  };

  const toggleNewPasswordVisibility = () => {
      setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmNewPasswordVisibility = () => {
      setShowConfirmNewPassword(!showConfirmNewPassword);
  };

  const handleBackClicked = async () => {
    navigate(-1);
  }

  return (
      <div className="flex-1 w-full space-y-4 bg-gray-900 p-5 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
        <h2 className="text-lg lg:text-xl text-cyan-200 font-bold text-center mb-6">
          Change Password
        </h2>
        <div className="flex flex-col gap-2">
          <label className="text-sm">Current Password</label>
          <div className="relative w-full">
            <input
              type={showCurrentPassword ? "text" : "password"}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              placeholder="Enter current password"
              autoComplete="current-password"
            />

            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleCurrentPasswordVisibility}
            >
              <FontAwesomeIcon
                icon={showCurrentPassword ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-sm">New Password</label>
          <div className="relative w-full">
            <input
              type={showNewPassword ? "text" : "password"}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              placeholder="Enter new password"
              autoComplete="new-password"
            />
            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleNewPasswordVisibility}
            >
              <FontAwesomeIcon
                icon={showNewPassword ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <label className="text-sm">Confirm New Password</label>
          <div className="relative w-full">
            <input
              type={showConfirmNewPassword ? "text" : "password"}
              className="w-full h-10 px-3 pr-10 text-sm text-black border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              placeholder="Confirm new password"
              autoComplete="new-password"
            />
            <div
              className="absolute inset-y-0 right-3 flex items-center cursor-pointer text-gray-700"
              onClick={toggleConfirmNewPasswordVisibility}
            >
              <FontAwesomeIcon
                icon={showConfirmNewPassword ? faEyeSlash : faEye}
              />
            </div>
          </div>
        </div>
        {message && <p className="text-green-400 text-sm">{message}</p>}
        {error && <p className="text-red-500 text-sm">{error}</p>}
        <div className="flex justify-center gap-4 pt-2">
          <button
            className="w-fit text-xs px-2 py-1 lg:text-sm bg-blue-600 text-white hover:bg-blue-700"
            onClick={handleChangePassword}
            disabled={loading || success} 
          >
            Change Password
          </button>

          <button
            className="w-fit px-2 py-1 text-xs lg:text-sm bg-blue-600 text-white hover:bg-blue-700"
            onClick={handleBackClicked}
          >
            Back
          </button>
        </div>
      </div>
  );
};

export default PDPassword;
